<template>
  <div class="container">
    <div class="row">
      <div class="col-xs-0 col-md-4"></div>
      <form v-if="showLogin" @submit.prevent="login" class="col-xs-12 col-md-4">
        <img src="@/assets/Logo.svg" alt="Logo" class="center-block" id="logo">
        <h2>Anmelden</h2>
        <div class="form-group">
          <label class="sr-only" for="credential-input">Email oder Mobilfunknummer</label>
          <input autofocus type="text" class="form-control" id="credential-input" placeholder="Email oder Mobilfunknummer" v-model="credential">
        </div>
        <button :disabled="isLoading" class="btn btn-primary">
          Anmelden
          <span v-if="isLoading" class="spinner"></span>
        </button>
      </form>
      <form v-else @submit.prevent="validateOtp" class="col-xs-12 col-md-4">
        <img src="@/assets/Logo.svg" alt="Logo" class="center-block" id="logo">
        <h2>Validieren</h2>
        <div class="form-group">
          <label class="sr-only" for="otp-input">Einmal-Code</label>
          <input autofocus type="text" class="form-control" id="otp-input" placeholder="Einmal-Code" v-model="otp">
        </div>
        <button :disabled="isLoading" class="btn btn-primary">
          Weiter
          <span v-if="isLoading" class="spinner"></span>
        </button>
      </form>
      <div class="col-xs-0 col-md-4"></div>
    </div>
    <Dialog @ok="redirect"
            :visible="noAdmin"
            title="Zugriff verweigert"
            message="Sie haben keine Berechtigung. Bitte wenden Sie sich an ihren Administrator."
            :show-cancel="false">
    </Dialog>
  </div>
</template>

<script>
import {communicator} from "@/util/communicator.js";
import {authenticate, isAdmin} from "@/util/authenticator.js";
import {router} from "@/util/router.js";
import {broadcast} from "@/util/eventHandler.js";
import Dialog from "@/components/partial/Dialog.vue";

export default {
  components: {Dialog},

  data() {
    return {
      credential: "",
      otp: "",
      showLogin: true,
      isLoading: false,
      noAdmin: false
    };
  },

  computed: {
    isEmail() {
      return this.credential && this.credential.includes("@");
    }
  },

  methods: {
    async login() {
      if(this.isLoading || !this.credential) return;
      this.isLoading = true;
      try {
        const payload = {
          type: "login"
        };
        payload[this.isEmail ? "email" : "msisdn"] = this.credential;
        const response = await communicator.post(`/authenticate/${this.isEmail ? "email" : "sms"}`, payload);
        console.log("[Login] Got response: ", response);
        this.showLogin = false;
      } catch (e) {
        broadcast("error", e.response.data);
      }
      this.isLoading = false;
    },

    async validateOtp() {
      if(this.isLoading) return;
      this.isLoading = true;
      try {
        const response = await communicator.post("/authenticate/finish", {
          otp: this.otp,
          method: this.isEmail ? "email" : "sms",
          credential: this.credential
        });
        authenticate(response.data.jwt);
        console.log("[Login] Got response: ", response);
        if(!isAdmin()) this.noAdmin = true;
        else this.redirect();
      } catch (e) {
        broadcast("error", e.response.data);
      }
      this.isLoading = false;
    },

    async redirect() {
      console.log("hello");
      await router.push("/");
    }
  }
};
</script>

<style scoped>
#logo {
  margin: 4rem auto;
}
</style>
